<template>
  <div class="">

    <Loading :show="!texts.length" />

    <div class="admin-sub-nav">
      <ul>
        <li :class="cat === category ? 'active' : ''"  v-for="cat in categories"><a @click.stop.prevent="setCat(cat)" href="#">{{cats[cat] || cat}}</a></li>
        <li class="language-selector" v-if="category === 'skischoolgroup'" :style="'background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + flag + '.svg);'">
          <select id="language" v-model="selectedLanguage">
            <option v-for="lang in languages" :key="lang" :value="lang">{{ lang }}</option>
          </select>
        </li>
      </ul>
    </div>

    <div :class="'admintextcontainer ' + (loading ? 'loading' : '')">

      <h1>Texter</h1>

      <hr />

      <div v-if="category === 'skilettingproduct'">
        <label for="sort">Sortera efter:</label>
        <select id="sort" v-model="sort" @change="fetchData">
          <option v-for="s in availableSorts" :key="s.value" :value="s.value">{{ s.text }}</option>
        </select>

        <hr />
      </div>

      <table v-if="category === 'accomodationaddon'">
        <thead>
          <tr>
            <th>Pool-ID</th>
            <th>Rubrik</th>
            <th>Bild</th>
            <th></th>
            <th>Beskrivning</th>
            <th>Plural</th>
            <th>Kopplad produkt</th>
            <th>Obl. städ</th>
          </tr>
        </thead>
        <tbody v-for="text in texts" v-if="text.category === category">
          <tr>
            <td><input type="number" @change="updateText(text)" v-model="text.id1" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text1"></textarea></td>
            <td><input type="text" @change="updateText(text)" v-model="text.text2" /></td>
            <td><img v-if="text.text2" style="height:2em;" :src="'https://static.booking.branasgruppen.se/static/svg/addons/' + text.text2" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text3"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text6"></textarea></td>
            <td><input type="number" @change="updateText(text)" v-model.number="text.text4" /></td>
            <td><input type="number" @change="updateText(text)" v-model="text.text7" /></td>
          </tr>
        </tbody>
        <tbody>
          <tr><td colspan="6" style="text-align:center; padding: 2em;"><button @click="add">Lägg till</button></td></tr>
        </tbody>
      </table>

      <table v-if="category === 'pagetexts'">
        <thead>
          <tr>
            <th>Kategori</th>
            <th>Nyckel</th>
            <th>Text</th>
          </tr>
        </thead>
        <tbody v-for="text in texts" v-if="text.category === category">
          <tr>
            <td><input type="text" @change="updateText(text)" v-model="text.slug" /></td>
            <td><input type="text"  @change="updateText(text)" v-model="text.text1" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text2" rows="10"></textarea></td>
          </tr>
        </tbody>
        <tbody>
          <tr><td colspan="3" style="text-align:center; padding: 2em;"><button @click="add">Lägg till</button></td></tr>
        </tbody>
      </table>

      <table v-if="category === 'skilettingproduct'">
        <thead>
          <tr>
            <th>Pool-ID</th>
            <th>Rubrik</th>
            <th>Bild</th>
            <th></th>
            <th>{{ 'Underrubrik' }}</th>
            <th>{{ 'Beskrivning' }}</th>
            <th>Underrubrik<br>ny skidhyra</th>
            <th>Grupperas med pool</th>
            <th>Ordning<br>på grupp</th>
            <th>Ordning<br>i grupp</th>
            <th>Bild (m. hjälm)</th>
            <th>{{ 'Kortare rubrik' }}</th>
            <th>Längdkategorier</th>
          </tr>
        </thead>
        <tbody v-for="(text, index) in texts" v-if="text.category === category">
          <tr>
            <td><input type="number" @change="updateText(text)" v-model="text.id1" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text1"></textarea><br/>{{text.original}}<br>{{text.meta}}</td>
            <td><textarea @change="updateText(text)" v-model="text.text2"></textarea></td>
            <td><img v-if="text.text2" style="height:2em;" :src="'https://static.booking.branasgruppen.se/static/img/produkter/' + text.text2" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text3"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text4"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text7"></textarea></td>
            <td><input type="number" @change="updateText(text)" v-model="text.number1" /></td>
            <td><input type="number" @change="updateText(text)" v-model="text.number2" /></td>
            <td><input type="number" @change="updateText(text)" v-model="text.number3" /></td>
            <td><textarea @change="updateText(text)" v-model="text.text5"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text6"></textarea></td>
            <td>
              <div v-if="bikeHeightCategories && bikeHeightCategories.length">
                <div style="font-size: 0.85em; margin-bottom: 0.25rem; max-width: 140px; word-break: break-word;font-weight: 400;">
                  <span v-for="(catId, catIndex) in getSelectedCategories(text.json1)" :key="catId" style="display: inline-block; background-color: #eee; padding: 2px 6px; border-radius: 4px; margin-right: 4px; margin-bottom: 4px;">
                    {{ getCategoryName(catId) }}
                  </span>
                </div>
                <button class="small white border tight" style="padding: 2px 6px; font-size: 0.8em;" @click.stop.prevent="openSelectModal(text)">{{ getSelectedCategories(text.json1).length ? 'Ändra' : 'Lägg till' }}</button>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr><td colspan="13" style="text-align:center; padding: 2em;"><button @click="add">Lägg till</button></td></tr>
        </tbody>
        <tbody>
          <tr><td colspan="13"><h2 style="margin-top: 3rem;">Produkter utan texter...</h2></td></tr>
        </tbody>
        <tbody v-for="text in missingTexts" v-if="text.category === category">
          <tr>
            <td>{{ text.id1 }}</td>
            <td>{{text.original}} | {{text.meta}}</td>
            <td colspan="11">&nbsp;</td>
          </tr>
        </tbody>
      </table>

      <table v-if="category === 'skischoolgroup'">
        <thead>
          <tr>
            <th style="min-width: 180px;">Grupp</th>
            <th>Rubrik</th>
            <th>Text</th>
            <th>Förkunskaper</th>
            <th>Bildrubrik</th>
            <th>Önskemål</th>
          </tr>
        </thead>
        <tbody v-for="text in texts" v-if="text.category === category">
          <tr :style="text.pool_ids && text.pool_ids.length ? '' : 'color: #AAA;'">
            <td>
              <div style="font-weight: bold; margin-bottom: 2px;">{{ friendlySkiSchoolGroupId(text.id1) }}</div>
              <div style="font-size: 0.8em; padding-left:0.25rem;">{{ text.id1 }}</div>
              <div v-if="text.product_names && text.product_names.length" style="font-size: 0.8em; padding-left:0.25rem;padding-top:0.25rem;">
                {{ text.product_names.join(', ') }}
              </div>
              <div v-if="text.pool_ids && text.pool_ids.length" style="font-size: 0.8em; padding-left:0.25rem;padding-top:0.25rem;">
                Pool(er): {{ text.pool_ids.join(', ') }}
              </div>
            </td>
            <td><textarea @change="updateText(text)" v-model="text.text1[selectedLanguage]"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text2[selectedLanguage]"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text3[selectedLanguage]"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text4[selectedLanguage]"></textarea></td>
            <td><textarea @change="updateText(text)" v-model="text.text5[selectedLanguage]"></textarea></td>
          </tr>
        </tbody>
        <tbody>
          <tr><td colspan="6" style="text-align:center; padding: 2em;"><button @click="add">Lägg till</button></td></tr>
        </tbody>
        <tbody v-if="missingTexts.filter(t => t.category === category).length">
          <tr><td colspan="6"><h2 style="margin-top: 3rem;">Skolor utan matchande text</h2></td></tr>
          <tr>
            <th>Pool-ID</th>
            <th>Namn / Kod</th>
            <th colspan="3">Nyckel</th>
            <th></th>
          </tr>
        </tbody>
        <tbody v-for="(text, index) in missingTexts" v-if="text.category === category">
          <tr>
            <td>{{ (text.pool_ids || []).join(', ') }}</td>
            <td>{{ (text.product_names || []).join(', ') }}</td>
            <td colspan="3">
              <b>{{ friendlySkiSchoolGroupId(text.id1) }}</b>
              <span style="color: #777; font-family: monospace; font-size: 0.85em; margin-left: 8px;">({{ text.id1 }})</span>
            </td>
            <td style="text-align: right;">
              <button class="small" @click.prevent="addFromMissing(text, index)">Lägg till text</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import API from '@/classes/API';
import Loading from '@/components/components/Loading';
import { mapMutations } from 'vuex';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
      texts: [],
      missingTexts: [],
      categories: [],
      bikeHeightCategories: [],
      category: 'accomodationaddon',
      cats: {
        accomodationaddon: 'Boendetillval',
        pagetexts: 'Sidtexter',
        skilettingproduct: 'Skidhyra',
        skischoolgroup: 'Skidskolegrupp',
      },
      selectedLanguage: 'sv',
      languages: ['sv', 'en', 'da'],
      sort: 'id1',
      availableSorts: [
        {
          value: 'id1',
          text: 'Pool-ID',
        },
        {
          value: 'number2',
          text: 'Ordning',
        },
      ],
    };
  },
  async mounted() {
    this.fetchData();
  },
  computed: {
    flag() {
      let flagUrl = '';
      this.SITE_CONFIG.languages.full.forEach((lang) => {
        if (lang.value === this.selectedLanguage) {
          flagUrl = lang.flag;
        }
      });

      return flagUrl;
    },
  },
  methods: {
    friendlySkiSchoolGroupId(id) {
      if (!id) return '';
      // Replace all dots with ", " "-" " år," and ", "
      return id
        .replace(/\./, '#1')
        .replace(/\./, '-')
        .replace(/\./, ' år')
        .replace('group#1', 'Grupp, ')
        .replace('private#1', 'Privat, ')
        .replace('snowboard#1', 'Snowboard, ')
        .replace(' årgreen', ' år, nivå 1 (grön)')
        .replace(' årblue', ' år, nivå 2 (blå)')
        .replace(' årred_snolek', ' år, snölek')
        .replace(' årred', ' år, nivå 3 (röd)')
        .replace(' år_private_1', ' år, nivå 1')
        .replace(' år_private_2', ' år, nivå 2')
        .replace(' år_private_3', ' år, nivå 3')
        .replace(' år_private_', ' år, privat')
        .replace(' årblack', ' år, nivå 4 (svart)');
    },
    setCat(cat) {
      this.category = cat;
      this.sort = cat === 'skilettingproduct' ? 'number2' : 'id1';
      this.fetchData();
    },
    add() {
      this.texts.push({
        category: this.category,
        slug: '',
        id1: '',
        id2: '',
        id3: '',
        text1: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text2: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text3: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text4: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text5: this.category === 'skischoolgroup' ? { sv: '', en: '', da: '' } : '',
        text6: '',
        text7: '',
        number1: null,
        number2: 999,
        number3: 9,
      });

      this.$toast.warning('OBS! Sparas inte förrän du skrivit något', 'Tillagd text', {
        position: 'topRight',
      });
    },
    addFromMissing(text, index) {
      this.missingTexts.splice(index, 1);
      this.texts.push({
        category: 'skischoolgroup',
        slug: '',
        id1: text.id1,
        id2: '',
        id3: '',
        pool_ids: text.pool_ids || [],
        product_names: text.product_names || [],
        text1: { sv: '', en: '', da: '' },
        text2: { sv: '', en: '', da: '' },
        text3: { sv: '', en: '', da: '' },
        text4: { sv: '', en: '', da: '' },
        text5: { sv: '', en: '', da: '' },
        text6: '',
        text7: '',
        number1: null,
        number2: 999,
        number3: 9,
      });
      this.$toast.info('Skidskolegruppen lades till i listan ovan. Fyll i text och spara.', 'Tillagd', {
        position: 'topRight',
      });
    },
    ...mapMutations([
      'openModal',
    ]),
    getCategoryName(id) {
      const found = this.bikeHeightCategories.find(c => String(c.id) === String(id));
      return found ? found.name : id;
    },
    getSelectedCategories(json1) {
      if (!json1) return [];
      if (Array.isArray(json1)) return json1;
      try {
        const decoded = JSON.parse(json1);
        return Array.isArray(decoded) ? decoded : [];
      } catch (e) {
        return [];
      }
    },
    openSelectModal(text) {
      const currentSelection = this.getSelectedCategories(text.json1);
      this.openModal(['AdminMultiSelectModal', {
        title: 'Välj längdkategorier',
        options: this.bikeHeightCategories,
        selected: currentSelection,
        click: (selectedIds) => {
          // eslint-disable-next-line no-param-reassign
          text.json1 = selectedIds;
          this.updateText(text);
        },
      }]);
    },
    async updateText(text) {
      this.loading = true;
      const { error, data, forceReload } = await API.post('/admin/update-texts', text);

      if (error) {
        this.$toast.error(error, 'Fel', {
          position: 'topRight',
        });
      } else {
        text.id = data.id; // eslint-disable-line

        this.$toast.success('Texten sparades', 'Sparat', {
          position: 'topRight',
        });
      }
      this.loading = false;

      if (forceReload) {
        this.fetchData();
      }
    },
    async fetchData() {
      this.loading = true;
      const { data, categories, missingTexts, bikeHeightCategories } = await API.get(`/texts?sort=${this.sort}&category=${this.category}`);
      this.texts = data.map((text) => {
        if (text.category === 'skischoolgroup') {
          const newText = Object.assign({}, text);
          ['text1', 'text2', 'text3', 'text4', 'text5'].forEach((field) => {
            newText[field] = JSON.parse(newText[field] || '{}') || '';
          });
          return newText;
        }
        return text;
      });
      this.categories = categories;
      this.missingTexts = missingTexts;
      this.bikeHeightCategories = bikeHeightCategories || [];
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.admintextcontainer
  admin-container()
  &.loading
    opacity 0.5
    pointer-events none
    filter grayscale(100%)

.admin-sub-nav
  admin-sub-nav()

table
  width 100%
th, td
  text-align left
  padding 2px 5px
  border-bottom 1px solid lightgrey
  vertical-align: top
  input
    font-weight normal
    &[type="number"]
      width 60px
    &[type="text"]
      width 200px !important
  textarea
    width 200px
tbody tr:last-child td
  padding-bottom 20px
input
  pading 2px 5px
.language-selector
  align-items center
  display: flex
  padding-left 2rem
  background-size 1rem
  background-repeat no-repeat
  background-position 0.5rem center
</style>



// WEBPACK FOOTER //
// Texts.vue?61d2ed97